<div class="row col-12 col-sm-12" [ngClass]="isMobile? 'px-0 m-0':''">
  @if (!isMobile) {
    <div class="col-3 col-sm-3">
      <app-my-account-left-sidenav [navState]="'AddressBookNavNode'"></app-my-account-left-sidenav>
    </div>
  }

  <div class="myAccountMyProfile" [ngClass]="isMobile? 'col-12' :'col-9 col-sm-9'">
    <h1 class="myProfileTopHeader m-0">{{'common.text_account_addressBook_addAddress'|cxTranslate}}
    </h1>
    <div class="myProfileBody addressForm-emergencyBody newmyProfileBody">
      <form [formGroup]="pwdchangeForm" (ngSubmit)="onSubmit()" novalidate autocomplete="off">
        <div class="myProfileformContainer " [ngClass]="isMobile ?'':'mb-3'">
          <!-- //reactiveform alone work -->
          <div class="d-flex col-xs-12 p-0 col-sm-12 col-md-12 col-lg-12 address-form-emergency-block">
            <label class="mr-3 p-0 col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
              <span class="label-content">{{'common.address_companyName'|cxTranslate}}</span>
              <input type="text" maxlength="255" class="form-control" placeholder=""
                formControlName="companyName" />
                <div>
                  @if ( (pwdform.companyName.invalid)&&(pwdform.companyName.touched)) {
                    <span class="text-danger-show-acc"
                      >
                    {{'common.address_companyName_invalid'|cxTranslate}}</span>
                  }
                </div>
              </label>
              <label class="mr-3 p-0 col-xs-12 col-sm-12 col-md-12 col-lg-6"
                [ngClass]="isMobile ? 'form-group': ''">
                <span class="label-content">{{'common.address_shipping_page_form_na'|cxTranslate}}</span>
                <input type="text" maxlength="255" class="form-control" placeholder=""
                  formControlName="line1" />
                  <div>
                    @if ( (pwdform.line1.invalid)&&(pwdform.line1.touched)) {
                      <span class="text-danger-show-acc"
                        >
                      {{'common.address_line1_invalid'|cxTranslate}}</span>
                    }
                  </div>
                </label>
              </div>
              <div class="form-group d-flex p-0 col-12" [ngClass]="isMobile ? 'flex-column': ''">
                <label class="mr-3 p-0 col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group"
                  [ngClass]="isMobile ? 'form-group': ''">
                  <span class="label-content">{{'common.address_line2_shipping_page_form'|cxTranslate}}</span>
                  <input type="text" maxlength="255" class="form-control" placeholder=""
                    formControlName="companyAddressTwo" />
                    <div>
                      @if ( (pwdform.line1.invalid)&&(pwdform.line1.touched)) {
                        <span class="text-danger-show-acc"
                          >
                        {{'common.address_line2_shipping_page_form'|cxTranslate}}</span>
                      }
                    </div>
                  </label>
                  <label class="col-xs-12 p-0 col-sm-12 col-md-12 col-lg-6">
                    <span class="label-content">{{'common.address_city_shipping_page_form'|cxTranslate}}</span>
                    <input type="text" maxlength="10" class="form-control" placeholder=""
                      formControlName="townCity" />
                      <div>
                        @if ( (pwdform.line1.invalid)&&(pwdform.line1.touched)) {
                          <span class="text-danger-show-acc"
                            >
                          {{'common.address_townCity_invalid'|cxTranslate}}</span>
                        }
                      </div>
                    </label>
                  </div>
                  <div class="d-flex p-0 col-12" [ngClass]="isMobile ? 'flex-column': ''">
                    <div class=" col-xs-12 p-0 mr-3 col-sm-12 col-md-12 col-lg-6 form-group">
                      <label for="titleCode"
                      class="control-label">{{'common.address_regionIso_shipping_form'|cxTranslate}}</label>
                      <div class="select-box">
                        <select name="country" class="form-control" formControlName="regionIso">
                          <option value="null" disabled selected>
                            {{'common.address_regionIso_shipping_form'|cxTranslate}}
                          </option>
                          @for (item of regions; track item; let i = $index) {
                            <option [value]="item.isocode">
                            {{item.name}}</option>
                          }
                        </select>
                      </div>
                      <div>
                        @if ( (pwdform.regionIso.invalid)&&(pwdform.regionIso.touched)) {
                          <span class="text-danger-show-acc"
                            >
                          {{'common.address_regionIso_invalid'|cxTranslate}}</span>
                        }
                      </div>
                    </div>
                    <div class=" col-xs-12 mr-3 p-0 col-sm-12 col-md-12 col-lg-6"
                      [ngClass]="isMobile ? 'form-group': ''">
                      <label for="postcode">{{'common.address_postalcode' | cxTranslate}}</label>
                      <input type="text" maxlength="10" formControlName="postcode" class="form-control"
                        name="postcode">
                        <div>
                          @if ( (pwdform.postcode.invalid)&&(pwdform.postcode.touched)) {
                            <span class="text-danger-show-acc"
                              >
                            {{'common.address_postcode_invalid'|cxTranslate}}</span>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="p-0 d-flex col-xs-12 col-sm-12 col-md-12" [ngClass]="isMobile ? 'flex-column': ''">
                      <div class=" col-xs-12 p-0 col-sm-12 col-md-12 col-lg-6 form-group">
                        <label for="titleCode"
                        class="control-label">{{'common.address_countryIso'|cxTranslate}}</label>
                        <div class="select-box">
                          <select name="country" class="form-control" formControlName="countryIso"
                            (change)="updateState()">
                            <option value="null" disabled selected>{{'common.address_countryIso'|cxTranslate}}
                            </option>
                            @for (item of update; track item; let i = $index) {
                              <option [value]="item.isocode">
                              {{item.name}}</option>
                            }
                          </select>
                        </div>
                        <div>
                          @if ( (pwdform.countryIso.invalid)&&(pwdform.countryIso.touched)) {
                            <span class="text-danger-show-acc"
                              >
                            {{'common.address_selectCountry'|cxTranslate}}</span>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="myProfileButtonContainer mt-5 row">
                    <div [ngClass]="isMobile ? ' d-flex flex-column w-100 padding-x': 'ml-auto'">
                      <button class=" btn btn-primary btn-blue fs-20 btn-cancel" type="button" (click)="redirector()"
                      [ngClass]="isMobile ? 'mb-3':''">{{'common.checkout_multi_cancel'|cxTranslate}}</button>
                      <button class=" btn btn-primary fs-20 save-address" [ngClass]="isMobile ? '': 'ml-3'"
                      type="submit">{{'common.text_button_save'|cxTranslate}}</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <ng-template #duplicateAddress>
            <div>
              <div mat-dialog-close class="closeraddress"><img src="/icons/close-kb.svg" width="20px"
              style="font-weight: bold;" alt=""></div>
              <div class="contentcloser">
                This address already exists in your address book
              </div>
            </div>
          </ng-template>